<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="p-3">
            <h2 class="mb-5">Add Notice Category</h2>
            <ElementCategories category_id="4" elementName="Notice"></ElementCategories>
        </div>
    </div>
</template>

<script>
import ElementCategories from "@/components/ElementComponents/ElementCategories";

export default {
    components: {
        ElementCategories,
    },
    methods: {},
    data() {
        return {
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'Notices',
                    to: '/notices/all'
                }, {
                    text: 'Notice Category',
                    href: '#'
                }
            ],
        }
    }
};
</script>
